<template>
  <b-row align-h="center" v-if="dataLoading">
    <b-spinner
      class="m-5"
      style="width: 4rem; height: 4rem"
      type="grow"
      variant="primary"
      label="Spinning"
    ></b-spinner>
  </b-row>

  <div v-else>
    <b-modal
      id="modal-partial"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      no-close-on-backdrop
      :title="$t('Partial Fee')"
    >
      <b-row class="">
        <b-col md="12">
          <b-form-group
            :label="$t('Enter Partial Fee %')"
            :invalid-feedback="$t('% should be between (0 - 100)')"
            ref="perc"
          >
            <b-form-input
              type="number"
              :placeholder="$t('Enter percentage')"
              v-model="partialPerc"
              @input="CheckPerc()"
            />
          </b-form-group>
        </b-col>

        <b-col class="text-right">
          <b-button
            variant="primary"
            :disabled="partialrequest"
            @click="savePartialFee()"
          >
            <b-spinner v-if="partialrequest" small type="grow" />
            <span v-else class="align-middle">{{ $t("Create") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="showSettings"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="showSettings = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="4" class="pr-0">
            <b-form-checkbox id="checkbox1" v-model="settings.printSlip">
              <h5 class="">{{ $t("Print Slip") }}</h5>
            </b-form-checkbox>
          </b-col>
          <b-col md="4" class="pr-0">
            <b-form-checkbox id="checkbox2" v-model="settings.sendSMS">
              <h5 class="">{{ $t("Send SMS") }}</h5>
            </b-form-checkbox>
          </b-col>
          <b-col md="4" v-if="noticeObj" class="pr-0">
            <b-form-checkbox v-model="noticeObj.valueBool">
              <h5 class="">{{ noticeObj.value }}</h5>
            </b-form-checkbox>
          </b-col>
          <b-col md="12" v-if="cHeadObj" class="mt-1">
            <b-form-checkbox v-model="cHeadObj.valueBool">
              <h5 class="">{{ cHeadObj.value }}</h5>
            </b-form-checkbox>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-form-group
              :label="$t('Print by')"
              :invalid-feedback="$t('Print by is required')"
              ref="printby"
            >
              <v-select
                ref="printby"
                v-model="settings.printBy"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="printOptions"
                :clearable="false"
                label="text"
                :reduce="(val) => val.value"
                :placeholder="$t('Select')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="" v-if="subObj && subObj.valueBool">
            <b-form-group
              :invalid-feedback="$t('Fees to Print is required')"
              ref="to_print"
            >
              <div class="d-flex justify-content-between pb-50">
                <label class="bv-no-focus-ring col-form-label p-0">{{
                  $t("Fees to Print")
                }}</label>
                <b-badge
                  variant="primary"
                  pill
                  class="cursor-pointer"
                  @click="toPrint = []"
                  >{{ $t("Clear All") }}</b-badge
                >
              </div>
              <v-select
                class="set_multi"
                ref="to_print"
                multiple
                :closeOnSelect="false"
                v-model="toPrint"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ id: 0, feeType: 'All' }, ...feeTypes]"
                label="feeType"
                :reduce="(val) => val.id"
                :placeholder="$t('Select')"
                @input="setAll()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Issue Date')"
              :invalid-feedback="$t('issue date is required')"
              ref="issue"
            >
              <flat-pickr
                ref="issue"
                :config="config"
                v-model="settings.issueDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Due Date')"
              :invalid-feedback="$t('due date is required')"
              ref="due"
            >
              <flat-pickr
                ref="due"
                :config="config"
                v-model="settings.dueDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="secondDueDate && secondDueDate.valueBool">
            <b-form-group
              :label="$t('2nd Due Date')"
              :invalid-feedback="$t('due date is required')"
              ref="second_due"
            >
              <flat-pickr
                :config="config"
                v-model="secondDueDate.value"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Expiry Date')"
              :invalid-feedback="$t('expiry date is required')"
              ref="exp"
            >
              <flat-pickr
                ref="exp"
                :config="config"
                v-model="settings.expiryDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Late fee')"
              :invalid-feedback="$t('Late fee is required')"
              ref="late"
            >
              <b-form-input
                type="number"
                v-model="settings.lateFee"
                :placeholder="$t('Enter late fee')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Timely Discount')"
              :invalid-feedback="$t('timely discount is required')"
              ref="dis"
            >
              <b-form-input
                type="number"
                v-model="settings.timelyDiscount"
                :placeholder="$t('Enter timely discount')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Bank Name')"
              :invalid-feedback="$t('Bank Name is required')"
              ref="bank"
            >
              <b-form-input
                v-model="settings.bankName"
                :placeholder="$t('Enter bank name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Title of account')"
              :invalid-feedback="$t('Title of account is required')"
              ref="acc_title"
            >
              <b-form-input
                v-model="settings.titleOfAccount"
                :placeholder="$t('Enter title of account')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Account Number')"
              :invalid-feedback="$t('Account Number is required')"
              ref="accNo"
            >
              <b-form-input
                v-model="settings.accountNumber"
                :placeholder="$t('Enter account number')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Fee Challan Instructions')"
              :invalid-feedback="$t('Please enter fee challan instruction')"
              ref="instr"
            >
              <b-form-textarea
                ref="instr"
                :placeholder="$t('Please write instruction for fee challan')"
                v-model="settings.instructions"
                rows="4"
              ></b-form-textarea>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="saveSettings()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else> {{ $t("Save") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <sidebar-content />
    </b-sidebar>

    <b-card>
      <!-- <b-row align-h="center" v-if="dataLoading">
        <b-spinner
          class="m-5"
          style="width: 4rem; height: 4rem"
          type="grow"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-row> -->

      <b-row>
        <b-col class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center" v-if="excludeMonthSetting && excludeMonthSetting.valueBool">
            <h3 class="mb-0 mr-1">{{ $t("Create Fee") }}</h3>
            <div class="d-flex flex-wrap">
              <b-badge
                v-for="(tag, index) in excludedMonthsList"
                :key="index"
                variant="light-danger"
                class="mr-50 p-50 d-flex align-items-center"
              >
                {{ tag.display }}
                <feather-icon
                  icon="XIcon"
                  size="14"
                  class="ml-50 cursor-pointer text-danger"
                  @click="removeExcluded(index)"
                />
              </b-badge>
            </div>
          </div>
          <div v-else>
            <h3 class="mb-0 mr-1">{{ $t("Create Fee") }}</h3>
          </div>
          <div class="d-flex align-items-center">
            <b-button
              variant="success"
              class="mr-1"
              :disabled="holding"
              @click="holdFee()"
            >
              <!-- <b-spinner v-if="holding" small type="grow" /> -->
              <span>{{ $t("Hold") }}</span>
            </b-button>
            <b-button
              variant="success"
              class="mr-1"
              :disabled="holding"
              @click="unholdFee()"
            >
              <!-- <b-spinner v-if="holding" small type="grow" /> -->
              <span>{{ $t("Unhold") }}</span>
            </b-button>

            <feather-icon
              v-if="!shouldHideSettings"
              icon="SettingsIcon"
              size="20"
              class="cursor-pointer"
              @click="showSettings = true"
            />
            <!-- <feather-icon
              v-if="!this.$store.state.creatorStates[0]"
              class="cursor-pointer ml-50"
              icon="ArrowDownIcon"
              size="26"
              @click="show(0)"
            />
            <feather-icon
              v-else
              class="cursor-pointer ml-50"
              icon="ArrowUpIcon"
              size="26"
              @click="hide(0)"
            /> -->
          </div>
        </b-col>
        <b-col md="12">
          <hr />
        </b-col>
        <b-collapse
          v-model="$store.state.creatorStates[0]"
          class="col-md-12"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('Select Months')"
                :invalid-feedback="$t('Please select a month')"
                ref="months"
              >
                <div
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 7px"
                    class="btn-icon"
                    v-for="mon in months"
                    :key="mon.id"
                    :variant="
                      variantMonth(mon.name) ? 'primary' : 'outline-primary'
                    "
                    @click="selectMonth(mon)"
                  >
                    {{ mon.name }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="12" class="">
              <b-form-group
                :label="$t('Select Fee Type')"
                :invalid-feedback="$t('Please select fee type')"
                ref="type"
              >
                <a class="my-buttons font-weight-bold">
                  <span v-if="!showAll" @click="showAll = true">{{
                    $t("Show More")
                  }}</span>
                  <span v-else @click="showAll = false">{{
                    $t("Show Less")
                  }}</span>
                </a>

                <!-- <feather-icon
              v-if="!showAll"
              v-b-tooltip.hover.left
              title="Show"
              class="my-buttons"
              icon="ArrowDownIcon"
              size="26"
              @click="showAll = true"
            />
            <feather-icon
              v-else
              v-b-tooltip.hover.left
              title="Hide"
              class="my-buttons"
              icon="ArrowUpIcon"
              size="26"
              @click="showAll = false"
            /> -->
                <div
                  :class="{ 'my-collapsing': !showAll }"
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 5px"
                    class="btn-icon"
                    v-for="fee in feeTypes"
                    :key="fee.id"
                    :variant="
                      variantFeetype(fee.id) ? 'primary' : 'outline-primary'
                    "
                    @click="selectFeetype(fee.id, fee.recurrence)"
                  >
                    {{ fee.feeType }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="12" class="" v-if="false">
              <!-- v-if="subObj && subObj.valueBool && showOnBehalf" -->
              <b-form-group
                :label="$t('Late on Behalf of')"
                :invalid-feedback="$t('Please select fee type')"
                ref="late_type"
              >
                <a class="my-buttons font-weight-bold">
                  <span v-if="!showAllLate" @click="showAllLate = true">{{
                    $t("Show More")
                  }}</span>
                  <span v-else @click="showAllLate = false">{{
                    $t("Show Less")
                  }}</span>
                </a>

                <!-- <feather-icon
              v-if="!showAll"
              v-b-tooltip.hover.left
              title="Show"
              class="my-buttons"
              icon="ArrowDownIcon"
              size="26"
              @click="showAll = true"
            />
            <feather-icon
              v-else
              v-b-tooltip.hover.left
              title="Hide"
              class="my-buttons"
              icon="ArrowUpIcon"
              size="26"
              @click="showAll = false"
            /> -->
                <div
                  :class="{ 'my-collapsing': !showAllLate }"
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 5px"
                    class="btn-icon"
                    v-for="fee in feeTypes.filter(
                      (el) => el.recurrence != 'after due date'
                    )"
                    :key="fee.id"
                    :variant="
                      myObj.onBehalf == fee.id ? 'primary' : 'outline-primary'
                    "
                    @click="selectOnBehalf(fee.id)"
                  >
                    {{ fee.feeType }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                :label="$t('Select Class')"
                :invalid-feedback="$t('class is required')"
                ref="class"
              >
                <v-select
                  ref="class"
                  multiple
                  :closeOnSelect="false"
                  v-model="classID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  @input="FillSections()"
                  :placeholder="$t('Select class')"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                :label="$t('Select Section')"
                :invalid-feedback="$t('section is required')"
                ref="section"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="secID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="admittedSections"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="checkSections()"
                  ref="section"
                  label="section"
                  :placeholder="$t('Select section')"
                />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group
                :label="$t('Select year')"
                :invalid-feedback="$t('year is required')"
                ref="year"
              >
                <v-select
                  v-model="myObj.year"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="years"
                  :clearable="false"
                  ref="year"
                  label="name"
                  :placeholder="$t('Select year')"
                />
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="usesAdmissionDateFilter">
              <b-form-group
                :label="$t('Admission Date From')"
                :invalid-feedback="$t('Admission date from is required')"
                ref="admission_from"
              >
                <flat-pickr
                  ref="admission_from"
                  :config="config"
                  v-model="admissionDateFrom"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="usesAdmissionDateFilter">
              <b-form-group
                :label="$t('Admission Date Till')"
                :invalid-feedback="$t('Admission date till is required')"
                ref="admission_till"
              >
                <flat-pickr
                  ref="admission_till"
                  :config="config"
                  v-model="admissionDateTill"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="excludeMonthSetting && excludeMonthSetting.valueBool">
              <b-form-group :label="$t('Exclude Month')">
                <v-select
                  v-model="excludeMonth"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="months"
                  label="name"
                  :reduce="(val) => val.name"
                  :placeholder="$t('Select Month')"
                  @input="addExcluded"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" v-if="excludeMonthSetting && excludeMonthSetting.valueBool">
              <b-form-group :label="$t('Exclude Year')">
                <v-select
                  v-model="excludeYear"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="excludeYears"
                  :placeholder="$t('Select Year')"
                  @input="addExcluded"
                />
              </b-form-group>
            </b-col>
            <b-col class="text-right" md="12">
              <b-button
                variant="success"
                :disabled="request || partialrequest"
                @click="saveFee()"
              >
                <div v-if="request">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Create Fee") }}</span>
              </b-button>
              <b-button
                v-if="partialObj && partialObj.valueBool"
                variant="warning"
                :disabled="request || partialrequest"
                class="ml-1"
                @click="openPartial()"
              >
                <span>{{ $t("Create Partial Fee") }}</span>
              </b-button>

              <b-button
                v-if="rights.delete"
                :disabled="requestDelete"
                variant="danger"
                class="ml-1"
                @click="undo()"
              >
                <div v-if="requestDelete">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Remove Fee") }}</span>
              </b-button>

              <b-button
                variant="outline-secondary"
                class="ml-1"
                @click="checkPrint('print')"
                :disabled="iPrint || challanJobVisible"
              >
                <b-spinner v-if="iPrint" small type="grow" />
                <feather-icon v-if="!iPrint" icon="PrinterIcon" class="mr-50" />
                <span v-if="!iPrint"> {{ $t("Print Challan") }} </span>
              </b-button>

              <b-button
                class="ml-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-success"
                @click="loadDetails()"
                :disabled="iMsg || detailLoading"
              >
                <b-spinner
                  v-if="iMsg || detailLoading"
                  small
                  type="grow"
                  class="mr-25"
                />
                <feather-icon v-if="!iMsg" icon="MailIcon" class="mr-50" />
                <span v-if="!iMsg">{{ $t("WhatsApp") }}</span>
              </b-button>

              <!-- Send Notification Button -->
              <b-button
                class="ml-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                @click="checkPrint('notification')"
                :disabled="iNotification"
              >
                <b-spinner v-if="iNotification" small type="grow" />
                <feather-icon
                  v-if="!iNotification"
                  icon="BellIcon"
                  class="mr-50"
                />
                <span v-if="!iNotification">{{ $t("Send Notification") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>
      </b-row>
    </b-card>

    <b-modal
      v-model="challanJobVisible"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="challan-job-modal"
      content-class="challan-job-modal__content"
      size="sm"
    >
      <div class="challan-job-modal__wrap">
        <div class="challan-job-modal__loader">
          <svg class="challan-job-modal__ring" viewBox="0 0 120 120">
            <circle
              class="challan-job-modal__ring-track"
              cx="60"
              cy="60"
              r="52"
            />
            <circle
              class="challan-job-modal__ring-fill"
              cx="60"
              cy="60"
              r="52"
              :style="{ strokeDashoffset: challanJobRingOffset }"
            />
          </svg>
          <div class="challan-job-modal__loader-center">
            <span class="challan-job-modal__percent">{{
              challanJobProgressDisplay
            }}</span>
            <span class="challan-job-modal__percent-sign">%</span>
          </div>
        </div>

        <div class="challan-job-modal__icon-badge">
          <feather-icon icon="FileTextIcon" size="20" />
        </div>

        <h5 class="challan-job-modal__title">
          {{ $t("Generating fee challans") }}
        </h5>
        <p class="challan-job-modal__message">{{ challanJobMessage }}</p>

        <div
          v-if="challanJobTotal > 0"
          class="challan-job-modal__stat"
        >
          <span class="challan-job-modal__stat-value">{{
            challanJobProcessed
          }}</span>
          <span class="challan-job-modal__stat-sep">/</span>
          <span class="challan-job-modal__stat-total">{{
            challanJobTotal
          }}</span>
          <span class="challan-job-modal__stat-label">{{
            $t("families")
          }}</span>
        </div>

        <div class="challan-job-modal__bar-wrap">
          <div
            class="challan-job-modal__bar-fill"
            :style="{ width: challanJobProgress + '%' }"
          ></div>
        </div>

        <p class="challan-job-modal__hint">
          {{ $t("Please keep this window open until generation completes.") }}
        </p>
      </div>
    </b-modal>

    <b-card v-if="showSelectionGrid">
      <b-row>
        <b-col md="6">
          <h3>{{ $t("Students") }}</h3>
          <p>
            <feather-icon icon="InfoIcon" size="16" />
            {{ $t("Select the students to send the message.") }}
          </p>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-1"
            @click="sendSelected()"
            :disabled="iMsg || detailLoading"
          >
            <b-spinner v-if="iMsg" small type="grow" />
            <feather-icon v-if="!iMsg" icon="MailIcon" class="mr-50" />
            <span v-if="!iMsg"
              >{{ $t("Send") }} ({{ this.selectedIDs.length }})
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="cancelSelection()"
            :disabled="iMsg || detailLoading"
          >
            <span>Cancel</span>
          </b-button>
        </b-col>
        <b-col md="12">
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search by name or grno')"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mt-1"
        show-empty
        :items="filters"
        :fields="stdFields"
        :busy="detailLoading"
        responsive
        hover
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #head()="scope">
          <div>
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #head(index)="data">
          <div>
            <b-form-checkbox
              inline
              :checked="
                selectedIDs.length > 0 &&
                selectedIDs.length == dueDetails.length
              "
              @change="(e) => setSelectAll(e)"
            >
              <span class="font-small-2">{{ $t(data.label) }}</span>
            </b-form-checkbox>
          </div>
        </template>

        <template #cell(index)="data">
          <b-form-checkbox
            inline
            :checked="selectedIDs.includes(data.item.id)"
            @change="(e) => setSelected(e, data.item.id)"
          >
            <b-badge variant="light-primary">
              {{ dueDetails.indexOf(data.item) + 1 }}
            </b-badge>
          </b-form-checkbox>
        </template>

        <template #cell(grNo)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(name)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(dues)="data">
          <b-badge variant="light-primary">
            {{ data.item.total_balance }}
          </b-badge>
        </template>
      </b-table>
    </b-card>

    <b-card v-if="false">
      <b-row>
        <b-col class="d-flex justify-content-between">
          <h3>Send Message to Defaulters</h3>
          <feather-icon
            v-if="!this.$store.state.creatorStates[1]"
            class="cursor-pointer"
            icon="ArrowDownIcon"
            size="26"
            @click="show(1)"
          />
          <feather-icon
            v-else
            class="cursor-pointer"
            icon="ArrowUpIcon"
            size="26"
            @click="hide(1)"
          />
        </b-col>
        <b-col md="12">
          <hr />
        </b-col>
        <b-collapse
          v-model="this.$store.state.creatorStates[1]"
          class="col-md-12"
        >
          <b-row>
            <b-col md="12">
              <b-form-group :label="$t('Filter Options')">
                <b-button
                  class="btn-icon mr-1"
                  v-for="item in filterOptions"
                  :key="item.value"
                  :variant="
                    msgObj.filterBy == item.value
                      ? 'primary'
                      : 'outline-primary'
                  "
                  @click="msgObj.filterBy = item.value"
                  v-b-tooltip.hover.top
                  :title="$t(item.tooltip)"
                >
                  {{ item.text }}
                </b-button>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="$t('Select Months')"
                :invalid-feedback="$t('Please select a month')"
                ref="msg_months"
              >
                <div
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 7px"
                    class="btn-icon"
                    :variant="
                      msgObj.months.includes(0) ? 'primary' : 'outline-primary'
                    "
                    @click="selectMsgMonth(0)"
                  >
                    All
                  </b-button>
                  <b-button
                    style="margin: 7px"
                    class="btn-icon"
                    v-for="mon in months"
                    :key="mon.id"
                    :variant="
                      msgObj.months.includes(mon.id)
                        ? 'primary'
                        : 'outline-primary'
                    "
                    @click="selectMsgMonth(mon.id)"
                  >
                    {{ mon.name }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>
            <b-col md="12" class="">
              <b-form-group
                :label="$t('Select Fee Type')"
                :invalid-feedback="$t('Please select fee type')"
                ref="msg_type"
              >
                <a class="my-buttons font-weight-bold">
                  <span v-if="!showAllMsg" @click="showAllMsg = true"
                    >Show More</span
                  >
                  <span v-else @click="showAllMsg = false">Show Less</span>
                </a>
                <div
                  :class="{ 'my-collapsing': !showAllMsg }"
                  style="
                    border: 1px solid lightgray;
                    padding: 5px;
                    border-radius: 5px;
                  "
                >
                  <b-button
                    style="margin: 5px"
                    class="btn-icon"
                    :variant="
                      msgObj.feesTypeIDs.includes(0)
                        ? 'primary'
                        : 'outline-primary'
                    "
                    @click="selectMsgFee(0)"
                  >
                    All
                  </b-button>
                  <b-button
                    style="margin: 5px"
                    class="btn-icon"
                    v-for="fee in feeTypes"
                    :key="fee.id"
                    :variant="
                      msgObj.feesTypeIDs.includes(fee.id)
                        ? 'primary'
                        : 'outline-primary'
                    "
                    @click="selectMsgFee(fee.id)"
                  >
                    {{ fee.feeType }}
                  </b-button>
                </div>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                :label="$t('Select Class')"
                :invalid-feedback="$t('class is required')"
                ref="msg_class"
              >
                <v-select
                  ref="class"
                  multiple
                  :closeOnSelect="false"
                  v-model="msgClassID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="classesOptions"
                  :clearable="false"
                  label="name"
                  :reduce="(val) => val.id"
                  @input="FillMsgSections()"
                  :placeholder="$t('Select class')"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="$t('Select Section')"
                :invalid-feedback="$t('section is required')"
                ref="msg_section"
              >
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="msgSecID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="msgSections"
                  :reduce="(val) => val.id"
                  :clearable="false"
                  @input="checkMsgSections()"
                  ref="section"
                  label="section"
                  :placeholder="$t('Select section')"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                :label="$t('Select year')"
                :invalid-feedback="$t('year is required')"
                ref="year"
              >
                <v-select
                  v-model="msgObj.year"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="years"
                  :clearable="false"
                  ref="year"
                  label="name"
                  :placeholder="$t('Select year')"
                />
              </b-form-group>
            </b-col>
            <b-col class="text-right" md="12">
              <b-button
                class="ml-1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                :disabled="iMsg"
              >
                <!-- @click="checkPrint('whatsapp')" -->
                <b-spinner v-if="iMsg" small type="grow" />
                <feather-icon v-if="!iMsg" icon="MailIcon" class="mr-50" />
                <span v-if="!iMsg">{{ $t("Send") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-collapse>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
  BFormTextarea,
  BCollapse,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { forEach } from "postcss-rtl/lib/affected-props";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { TheMask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { stat } from "fs";

export default {
  components: {
    //Multiselect,
    BModal,
    BCard,
    BRow,
    BBadge,
    BTable,
    flatPickr,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormTextarea,
    BCollapse,
    vSelect,
    TheMask,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
      this.LoadFSettings();
      this.loadSubSetting();
      this.LoadSettingsAll();
    }
  },
  computed: {
    isProfectusDomain() {
      return this.reportDomain === "myskoolprofectus";
    },
    usesAdmissionDateFilter() {
      return ["myskoolprofectus", "myskool"].includes(this.reportDomain);
    },
    shouldHideSettings() {
      return this.hideSettings
        ? this.hideSettings.valueBool &&
            this.role.toLowerCase() != "administrator"
        : false;
    },
    filters: function () {
      const keyword = this.searchQuery.toLowerCase();
      return this.dueDetails.filter((pro) => {
        return (
          (pro.name && pro.name.toLowerCase().match(keyword)) ||
          pro.grNo.toLowerCase().match(keyword)
        );
      });
    },
    challanJobProgressDisplay() {
      return Math.min(
        100,
        Math.max(0, Math.round(Number(this.challanJobProgress) || 0))
      );
    },
    challanJobRingOffset() {
      const circumference = 2 * Math.PI * 52;
      const progress = this.challanJobProgressDisplay;
      return circumference - (progress / 100) * circumference;
    },
  },
  data() {
    let yList = [];
    for (let i = 2015; i <= 2050; i++) {
      yList.push(i);
    }
    return {
      rights: {},
      role: this.$store.state.userData.roles,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      admissionDateFrom: null,
      admissionDateTill: null,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      iMsg: false,
      iPrint: false,
      iNotification: false,
      showAll: false,
      showAllLate: false,
      requestDelete: false,
      request: false,
      saving: false,
      dataLoading: false,
      prevObj: {},
      myObj: {
        id: 0,
        year: new Date().getFullYear(),
        userID: this.$store.state.userData.userID,
        feesTypeIDs: [],
        months: [],
        excludedMonths: [],
        classIDs: [],
        secIDs: [],
        campusID: this.$store.state.userData.cId,
        onBehalf: 0,
      },
      classID: [0],
      secID: [0],
      assignedClass: null,
      feeTypes: [],
      classes: [],
      classesOptions: [{ name: "All Classes", id: 0 }],
      admittedSections: [{ section: "All Sections", id: 0 }],
      selectedMonths: [],
      months: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      years: yList,
      excludeMonth: null,
      excludeYear: null,
      excludedMonthsList: [],
      excludeYears: [2024, 2025, 2026, 2027, 2028],
      excludeMonthSetting: null,
      showSettings: false,
      settings: {
        id: 0,
        campusID: this.$store.state.userData.cId,
        issueDate: null,
        dueDate: null,
        expiryDate: null,
        lateFee: 0,
        timelyDiscount: 0,
        printSlip: false,
        sendSMS: false,
        bankName: "",
        accountNumber: "",
        printBy: "",
        titleOfAccount: "",
      },
      printOptions: [
        {
          text: "Student",
          value: "student",
        },
        {
          text: "Family",
          value: "family",
        },
      ],
      subObj: null,
      showOnBehalf: false,
      toPrint: [],
      noticeObj: null,
      cHeadObj: null,
      hideSettings: null,
      secondDueDate: null,
      partialObj: null,
      partialPerc: 100,
      partialrequest: false,
      filterOptions: [
        {
          text: "Include",
          tooltip: "Include filter will include the selected options",
          value: "include",
        },
        {
          text: "Exclude",
          tooltip: "Exclude filter will exclude the selected options",
          value: "exclude",
        },
      ],
      msgObj: {
        filterBy: "include",
        year: new Date().getFullYear(),
        userID: this.$store.state.userData.userID,
        feesTypeIDs: [0],
        months: [0],
        classIDs: [],
        secIDs: [],
        campusID: this.$store.state.userData.cId,
      },
      showAllMsg: false,
      msgClassID: [0],
      msgSecID: [0],
      msgSections: [{ section: "All Sections", id: 0 }],
      holding: false,
      showSelectionGrid: false,
      detailLoading: false,
      dueDetails: [],
      stdFields: [
        { label: "S.No", key: "index" },
        { label: "grno", key: "grNo" },
        { label: "name", key: "name" },
        { label: "dues", key: "dues" },
      ],
      selectedIDs: [],
      isSelection: false,
      searchQuery: "",
      challanJobVisible: false,
      challanJobProgress: 0,
      challanJobMessage: "",
      challanJobProcessed: 0,
      challanJobTotal: 0,
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    async loadDetails() {
      if (this.isSelection) {
        const s1 = this.CheckClass();
        const s2 = this.CheckSec();
        if (s1 && s2) {
          this.showSelectionGrid = true;
          // reset selection
          this.setSelectAll(false);

          const payload = {
            cID: this.classID[0] == 0 ? [] : this.classID,
            secID: this.secID[0] == 0 ? [] : this.secID,
          };
          // console.log(payload);
          this.detailLoading = true;

          let res = await this.post({
            url:
              this.$store.state.domain +
              "feesChallan/LoadStudents?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: payload,
            subjects: true,
            context: this,
            token: this.$store.state.userData.token,
          });
          this.dueDetails = res;
          this.detailLoading = false;
          this.setSelectAll(true);
        } else {
          this.$bvToast.toast(this.$t("Please select class and section"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } else {
        this.checkPrint("whatsapp");
      }
    },
    setSelectAll(e) {
      if (e) {
        this.selectedIDs = this.dueDetails.map((el) => el.id);
      } else {
        this.selectedIDs = [];
      }
    },
    setSelected(e, id) {
      if (e) {
        this.selectedIDs.push(id);
      } else {
        this.selectedIDs = this.selectedIDs.filter((el) => el != id);
      }
    },
    sendSelected() {
      if (this.selectedIDs.length > 0) this.checkPrint("whatsapp");
      else {
        this.$bvToast.toast("Please select the student", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    cancelSelection() {
      this.selectedIDs = [];
      this.showSelectionGrid = false;
    },

    show(ind) {
      if (ind == 0) {
        this.$store.commit("setCreatorStates", [
          true,
          this.$store.state.creatorStates[1],
        ]);
      } else {
        this.$store.commit("setCreatorStates", [
          this.$store.state.creatorStates[0],
          true,
        ]);
      }
    },
    hide(ind) {
      if (ind == 0) {
        this.$store.commit("setCreatorStates", [
          false,
          this.$store.state.creatorStates[1],
        ]);
      } else {
        this.$store.commit("setCreatorStates", [
          this.$store.state.creatorStates[0],
          false,
        ]);
      }
    },

    selectMsgMonth(id) {
      if (id == 0) {
        this.msgObj.months = [0];
      } else {
        this.msgObj.months = this.msgObj.months.filter((el) => el != 0);
        if (this.msgObj.months.includes(id)) {
          this.msgObj.months = this.msgObj.months.filter((el) => el != id);
        } else {
          this.msgObj.months.push(id);
        }
      }
      // console.log(this.msgObj.months);
    },
    selectMsgFee(id) {
      if (id == 0) {
        this.msgObj.feesTypeIDs = [0];
      } else {
        this.msgObj.feesTypeIDs = this.msgObj.feesTypeIDs.filter(
          (el) => el != 0
        );
        if (this.msgObj.feesTypeIDs.includes(id)) {
          this.msgObj.feesTypeIDs = this.msgObj.feesTypeIDs.filter(
            (el) => el != id
          );
        } else {
          this.msgObj.feesTypeIDs.push(id);
        }
      }
      // console.log(this.msgObj.feesTypeIDs);
    },
    FillMsgSections() {
      if (this.msgClassID[0] == 0 && this.msgClassID.length !== 1) {
        this.msgClassID = this.msgClassID.filter((e) => e !== 0);
        // console.log(this.msgClassID);
        this.classes.forEach((elem) => {
          if (this.msgClassID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSections.push(el));
            } else {
              // console.log("null");
              this.msgSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (
        this.msgClassID[this.msgClassID.length - 1] !== 0 &&
        this.msgClassID.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.msgClassID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.msgSections.push(el));
            } else {
              // console.log("null");
              this.msgSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (this.msgClassID[this.msgClassID.length - 1] == 0) {
        this.msgClassID = [0];
        // console.log(this.msgClassID);
        this.msgSections = [{ section: "All Sections", id: 0 }];
        this.msgSecID = [0];
      } else {
        this.msgSections = [{ section: "All Sections", id: 0 }];
        this.msgSecID = [0];
      }
      this.CheckClass();
    },
    checkMsgSections() {
      // console.log(this.msgSecID);
      if (this.msgSecID[0] == 0 && this.msgSecID.length !== 1) {
        this.msgSecID = this.msgSecID.filter((e) => e !== 0);
        // console.log(this.msgSecID);
      } else if (this.msgSecID[this.msgSecID.length - 1] == 0) {
        this.msgSecID = [0];
        // console.log(this.msgSecID);
      }
      // this.CheckSec();
    },

    setAll() {
      if (this.toPrint.includes(0)) {
        this.toPrint = this.feeTypes.reduce((acc, c) => {
          acc.push(c.id);
          return acc;
        }, []);
      }
    },
    async loadSubSetting() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "fee_sub_categories",
          "fee_notice",
          "challan_with_header",
          "partial-fee",
          "second_due_date",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      this.subObj = res.find((el) => el.key == "fee_sub_categories");
      this.noticeObj = res.find((el) => el.key == "fee_notice");
      this.cHeadObj = res.find((el) => el.key == "challan_with_header");
      this.partialObj = res.find((el) => el.key == "partial-fee");
      this.secondDueDate = res.find((el) => el.key == "second_due_date");

      // console.log(this.noticeObj);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["hide_fee_settings", "challan_std_selection", "exclude-month"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // hide fee settings and should not receive fee before issue date
      this.hideSettings = res.find((el) => el.key == "hide_fee_settings");
      this.excludeMonthSetting = res.find((el) => el.key == "exclude-month");
      const obj = res.find((el) => el.key == "challan_std_selection");
      this.isSelection = obj && obj.valueBool;
    },

    async LoadFSettings() {
      let myitem = await this.get({
        url:
          this.$store.state.domain +
          "FeeSettings/LoadData?campusID=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      });
      if (myitem == null || myitem == "") {
        this.settings = {
          id: 0,
          campusID: this.$store.state.userData.cId,
          issueDate: null,
          dueDate: null,
          expiryDate: null,
          lateFee: 0,
          timelyDiscount: 0,
          printSlip: false,
          sendSMS: false,
          bankName: "",
          accountNumber: "",
          printBy: "student",
          titleOfAccount: "",
        };
      } else {
        this.settings = myitem;
      }
    },
    async saveSettings() {
      // console.log(this.settings);
      this.settings.lateFee = parseInt(this.settings.lateFee);
      this.settings.timelyDiscount = parseInt(this.settings.timelyDiscount);
      this.saving = true;

      var status = await this.post({
        url:
          this.$store.state.domain +
          "FeeSettings/Save?db=" +
          this.$store.state.userData.db,
        body: this.settings,
        message: "Settings saved successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });

      if (this.noticeObj || this.cHeadObj || this.secondDueDate) {
        let data = [];
        if (this.noticeObj) data.push(this.noticeObj);
        if (this.cHeadObj) data.push(this.cHeadObj);
        if (this.secondDueDate) data.push(this.secondDueDate);

        var sett = await this.post({
          url:
            this.$store.state.domain +
            "Settings/SaveNew?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: data,
          importing: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (sett) {
          this.loadSubSetting();
        }
      }
      if (status) {
        this.showSettings = false;
      }
      this.saving = false;
    },
    variantFeetype(id) {
      return this.myObj.feesTypeIDs.includes(id);
    },
    selectFeetype(id, recurr) {
      if (this.myObj.feesTypeIDs.length == 0) {
        this.myObj.feesTypeIDs.push(id);
      } else {
        let data = this.myObj.feesTypeIDs.filter((el) => {
          return el !== id;
        });
        // console.log("data", data);
        if (data.length == this.myObj.feesTypeIDs.length) {
          this.myObj.feesTypeIDs.push(id);
        } else {
          this.myObj.feesTypeIDs = data;
        }
      }
      //
      if (recurr == "after due date") {
        if (this.variantFeetype(id) == true) {
          this.showOnBehalf = true;
        } else {
          this.showOnBehalf = false;
          this.myObj.onBehalf = 0;
        }
      }
      // console.log(this.myObj.feesTypeIDs);
    },
    selectOnBehalf(id) {
      if (this.myObj.onBehalf == id) this.myObj.onBehalf = 0;
      else this.myObj.onBehalf = id;
    },
    variantMonth(name) {
      return this.myObj.months.includes(name);
    },
    selectMonth(month) {
      if (this.myObj.months.length == 0) {
        this.myObj.months.push(month.name);
        this.selectedMonths.push(month.id);
      } else {
        let data = this.myObj.months.filter((el) => {
          return el !== month.name;
        });
        if (data.length == this.myObj.months.length) {
          this.myObj.months.push(month.name);
        } else {
          this.myObj.months = data;
        }

        //Selected Months
        let dataa = this.selectedMonths.filter((el) => {
          return el !== month.id;
        });
        if (dataa.length == this.selectedMonths.length) {
          this.selectedMonths.push(month.id);
        } else {
          this.selectedMonths = dataa;
        }
      }
      // console.log(this.selectedMonths);
    },
    addExcluded() {
      if (this.excludeMonth && this.excludeYear) {
        const fullString = `${this.excludeMonth}-${this.excludeYear}`;
        if (!this.myObj.excludedMonths.includes(fullString)) {
          this.myObj.excludedMonths.push(fullString);
          this.excludedMonthsList.push({
            month: this.excludeMonth,
            year: this.excludeYear,
            display: fullString,
          });
        }
        // Reset selection
        this.excludeMonth = null;
        this.excludeYear = null;
      }
    },
    removeExcluded(index) {
      this.myObj.excludedMonths.splice(index, 1);
      this.excludedMonthsList.splice(index, 1);
    },
    FillSections() {
      // console.log(this.classID);

      //   if (this.classID.includes(0) && this.classID.length == 2) {
      //     this.classID = this.classID.filter((e) => e !== 0);
      //     console.log(this.classID);
      //   }
      if (this.classID[0] == 0 && this.classID.length !== 1) {
        this.classID = this.classID.filter((e) => e !== 0);
        // console.log(this.classID);
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (
        this.classID[this.classID.length - 1] !== 0 &&
        this.classID.length == 1
      ) {
        this.classes.forEach((elem) => {
          if (this.classID.includes(elem.cls.id)) {
            if (elem.sections.length != 0) {
              elem.sections.forEach((el) => this.admittedSections.push(el));
            } else {
              // console.log("null");
              this.admittedSections = [{ section: "All Sections", id: 0 }];
            }
          }
        });
      } else if (this.classID[this.classID.length - 1] == 0) {
        this.classID = [0];
        // console.log(this.classID);
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
      } else {
        this.admittedSections = [{ section: "All Sections", id: 0 }];
        this.secID = [0];
      }
      this.CheckClass();
    },
    checkSections() {
      // console.log(this.secID);
      if (this.secID[0] == 0 && this.secID.length !== 1) {
        this.secID = this.secID.filter((e) => e !== 0);
        // console.log(this.secID);
      } else if (this.secID[this.secID.length - 1] == 0) {
        this.secID = [0];
        // console.log(this.secID);
      }
      this.CheckSec();
    },

    CheckType() {
      var elem = this.$refs["type"];
      if (this.myObj.feesTypeIDs.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckMonths() {
      var elem = this.$refs["months"];
      if (this.myObj.months.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckYear() {
      var elem = this.$refs["year"];
      if (this.myObj.year == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckClass() {
      var elem = this.$refs["class"];
      if (this.classID.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckSec() {
      var elem = this.$refs["section"];
      if (this.secID.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.feeTypes = await this.get(obj);
      // console.log("fee", this.feeTypes);

      var obj2 = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj2);
      // console.log("class", this.classes);
      this.classes.forEach((el) => this.classesOptions.push(el.cls));
      this.dataLoading = false;
    },

    async undo() {
      if (this.classID[0] !== 0) this.myObj.classIDs = this.classID;
      else this.myObj.classIDs = [];
      if (this.secID[0] !== 0) this.myObj.secIDs = this.secID;
      else this.myObj.secIDs = [];

      this.CheckType();
      this.CheckMonths();
      this.CheckYear();
      if (
        this.CheckType() != false &&
        this.CheckMonths() != false &&
        this.CheckYear() != false
      ) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You won't be able to revert this!"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, Delete it!"),
        });

        if (result.isConfirmed) {
          this.requestDelete = true;
          const requestBody = this.prepareFeeRequestBody();
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/RemoveFee?db=" +
              this.$store.state.userData.db,
            body: requestBody,
            message: "Fee removed successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });

          if (status) {
            this.prevObj = this.myObj;
            this.myObj = {
              id: 0,
              year: new Date().getFullYear(),
              userID: this.$store.state.userData.userID,
              feesTypeIDs: [],
              months: [],
              excludedMonths: [],
              classIDs: [],
              secIDs: [],
              campusID: this.$store.state.userData.cId,
            };
            this.excludedMonthsList = [];
            this.selectedMonths = [];
            this.classID = [0];
            this.admittedSections = this.admittedSections = [
              { section: "All Sections", id: 0 },
            ];
            this.secID = [0];
            this.requestDelete = false;
          }
        }
      }
    },
    resolveGenerateChallanController() {
      if (
        this.settings.printBy != null &&
        this.settings.printBy.toLowerCase() == "student"
      ) {
        return "GenerateChallanStudent";
      }
      return "GenerateChallan";
    },
    buildChallanGeneratePayload(options = {}) {
      const includeSelectedStudents = !!options.includeSelectedStudents;
      if (this.classID[0] !== 0) this.myObj.classIDs = this.classID;
      else this.myObj.classIDs = [];
      if (this.secID[0] !== 0) this.myObj.secIDs = this.secID;
      else this.myObj.secIDs = [];

      const pObj = {
        fCode: 0,
        sID: 0,
        cID: this.classID,
        secID: this.secID,
        feeTypeID: this.myObj.feesTypeIDs,
        months: this.selectedMonths,
        excludedMonths: this.myObj.excludedMonths,
        year: this.myObj.year,
        familyWise: true,
        userID: this.$store.state.userData.userID,
        feeIDs: [],
      };

      if (includeSelectedStudents) {
        pObj.sIDs = this.isSelection ? this.selectedIDs : [];
      }

      if (pObj.cID[0] == 0) pObj.cID = [];
      if (pObj.secID[0] == 0) pObj.secID = [];
      return pObj;
    },
    isWideChallanGenerateFilters(pObj) {
      const classWide = !pObj.cID || pObj.cID.length === 0;
      const secWide = !pObj.secID || pObj.secID.length === 0;
      return classWide && secWide;
    },
    shouldUseGenerateChallanAsync(controller, pObj) {
      if (controller !== "GenerateChallan") return false;
      if (this.isSelection && (this.selectedIDs || []).length > 0) {
        return false;
      }
      return this.isWideChallanGenerateFilters(pObj);
    },
    buildChallanGenerateQuery({ exp, notification }) {
      let query =
        "db=" +
        encodeURIComponent(this.$store.state.userData.db) +
        "&cID=" +
        encodeURIComponent(this.$store.state.userData.cId);
      if (exp === true) query += "&exp=true";
      else if (exp === false) query += "&exp=false";
      if (notification) query += "&notification=true";
      return query;
    },
    authHeaders() {
      return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.$store.state.userData.token}`,
      };
    },
    updateChallanJobProgress(st) {
      this.challanJobProgress = Math.min(
        100,
        Math.max(0, Number(st.percent) || 0)
      );
      this.challanJobProcessed = Number(st.processed) || 0;
      this.challanJobTotal = Number(st.total) || 0;
      if (st.status === "enqueued") {
        this.challanJobMessage = this.$t("Queued — starting shortly…");
        return;
      }
      if (this.challanJobTotal > 0) {
        this.challanJobMessage = this.$t("Processing families in the background");
      } else {
        this.challanJobMessage = this.$t("Building challans for your selection");
      }
    },
    async startGenerateChallanAsyncJob(pObj, query) {
      const res = await axios.post(
        this.$store.state.domain +
          "feesChallan/GenerateChallanAsync?" +
          query,
        pObj,
        { headers: this.authHeaders() }
      );
      return res.data;
    },
    async pollChallanGenerateJob(jobID) {
      while (true) {
        await new Promise((r) => setTimeout(r, 1500));
        const res = await axios.get(
          this.$store.state.domain + "BackgroundJobs/GetJobStatus/" + jobID,
          { headers: { Authorization: `Bearer ${this.$store.state.userData.token}` } }
        );
        const st = res.data || {};
        this.updateChallanJobProgress(st);
        if (st.status === "failed") {
          throw new Error(
            st.error || this.$t("Challan generation failed")
          );
        }
        if (st.status === "succeeded") return;
      }
    },
    async fetchGenerateChallanJobResult(jobID) {
      const res = await axios.get(
        this.$store.state.domain +
          "feesChallan/GetGenerateChallanJobResult/" +
          jobID,
        { headers: { Authorization: `Bearer ${this.$store.state.userData.token}` } }
      );
      return res.data;
    },
    async fetchGenerateChallanJobResultWithRetry(jobID) {
      for (let attempt = 0; attempt < 5; attempt++) {
        const result = await this.fetchGenerateChallanJobResult(jobID);
        if (result.status === "success" && Array.isArray(result.data)) {
          return result.data;
        }
        if (result.status === "error") {
          throw new Error(result.message || this.$t("Challan generation failed"));
        }
        await new Promise((r) => setTimeout(r, 1000));
      }
      throw new Error(this.$t("Result not ready"));
    },
    async runGenerateChallanAsync(pObj, query, successMessage) {
      this.challanJobVisible = true;
      this.challanJobProgress = 0;
      this.challanJobProcessed = 0;
      this.challanJobTotal = 0;
      this.challanJobMessage = this.$t("Preparing your request…");

      try {
        const start = await this.startGenerateChallanAsyncJob(pObj, query);
        if (start.status === "error") {
          throw new Error(start.message || this.$t("Invalid request"));
        }
        const jobID = start.jobID;
        if (!jobID) {
          throw new Error(this.$t("No job ID returned"));
        }
        await this.pollChallanGenerateJob(jobID);
        const fcIDs = await this.fetchGenerateChallanJobResultWithRetry(jobID);
        if (successMessage) {
          this.$bvToast.toast(successMessage, {
            title: this.$t("Notification"),
            variant: "success",
            toaster: "b-toaster-top-right",
          });
        }
        return fcIDs;
      } catch (error) {
        this.$bvToast.toast(
          (error && error.message) ||
            this.$t("Challan generation failed"),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-right",
          }
        );
        return false;
      } finally {
        this.challanJobVisible = false;
        this.challanJobProgress = 0;
        this.challanJobMessage = "";
        this.challanJobProcessed = 0;
        this.challanJobTotal = 0;
      }
    },
    async requestGenerateChallanFcIDs({
      controller,
      pObj,
      exp,
      notification,
      postMessage,
      ignoreTimeout,
      ignoreMessage,
    }) {
      const query = this.buildChallanGenerateQuery({ exp, notification });
      if (this.shouldUseGenerateChallanAsync(controller, pObj)) {
        return this.runGenerateChallanAsync(
          pObj,
          query,
          postMessage || null
        );
      }

      const objData = await this.postObj({
        url:
          this.$store.state.domain +
          "feesChallan/" +
          controller +
          "?" +
          query,
        body: pObj,
        message: postMessage,
        context: this,
        ignoreTimeout: !!ignoreTimeout,
        ignoreMessage: !!ignoreMessage,
        token: this.$store.state.userData.token,
      });
      return objData;
    },
    openChallanPrintWindow(objData, ffc) {
      if (!objData || !objData.length) return;
      let header = this.cHeadObj ? this.cHeadObj.valueBool : false;
      var fcIDRange =
        this.reportDomain === "myskooliuss"
          ? objData.join(",")
          : objData[0] + "-" + objData[objData.length - 1];
      let url =
        `https://${this.reportDomain}.myskool.app/Fee/Challan?dbb=` +
        this.$store.state.userData.db +
        "&sID=" +
        0 +
        "&cID=" +
        this.$store.state.userData.cId +
        "&cls=" +
        this.myObj.classIDs +
        "&sec=" +
        this.myObj.secIDs +
        "&feeType=" +
        this.myObj.feesTypeIDs +
        "&fCode=" +
        ffc +
        "&fcID=" +
        fcIDRange +
        "&duedate=" +
        this.settings.dueDate +
        "&header=" +
        header;

      let urlSelectedMonth = url + "&month=" + this.selectedMonths;
      window.open(urlSelectedMonth, "_blank");
    },
    async whatsApp() {
      this.iMsg = true;

      await this.LoadFSettings();
      var controller = this.resolveGenerateChallanController();

      try {
        var pObj = this.buildChallanGeneratePayload({
          includeSelectedStudents: true,
        });

        this.$bvToast.toast(this.$t("Challan sending on WhatsApp"), {
          title: this.$t("WhatsApp"),
          variant: "success",
          toaster: "b-toaster-top-right",
        });

        await this.requestGenerateChallanFcIDs({
          controller,
          pObj,
          exp: true,
          postMessage: "Challan sent on WhatsApp",
          ignoreTimeout: true,
        });
      } catch (error) {
      } finally {
        this.iMsg = false;
      }
    },

    async sendNotification() {
      this.iNotification = true;

      await this.LoadFSettings();
      var controller = "GenerateChallanStudent";

      try {
        if (this.classID[0] !== 0) this.myObj.classIDs = this.classID;
        else this.myObj.classIDs = [];
        if (this.secID[0] !== 0) this.myObj.secIDs = this.secID;
        else this.myObj.secIDs = [];

        var pObj = {
          fCode: 0,
          sID: 0,
          cID: this.classID,
          secID: this.secID,
          feeTypeID: this.myObj.feesTypeIDs,
          months: this.selectedMonths,
          excludedMonths: this.myObj.excludedMonths,
          year: this.myObj.year,
          familyWise: true,
          userID: this.$store.state.userData.userID,
          feeIDs: [],
        };

        if (pObj.cID[0] == 0) pObj.cID = [];
        if (pObj.secID[0] == 0) pObj.secID = [];

        this.$bvToast.toast(this.$t("Notification sending") + "...", {
          title: this.$t("Notification"),
          variant: "success",
          toaster: "b-toaster-top-right",
        });

        var res = await this.postObj({
          url:
            this.$store.state.domain +
            "feesChallan/" +
            controller +
            "?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&exp=true&notification=true",
          body: pObj,
          message: "Notification sent successfully",
          context: this,
          ignoreTimeout: true,
          ignoreMessage: true,
          token: this.$store.state.userData.token,
        });

        if (res === false) {
          this.$bvToast.toast(
            this.$t(
              "Fee Challan & Notifications are in progress. This process takes some time to complete, please check your outbox shortly."
            ),
            {
              title: this.$t("In Progress"),
              variant: "info",
              toaster: "b-toaster-top-right",
            }
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.iNotification = false;
      }
    },
    async checkPrint(text) {
      let result = await Swal.fire({
        // title: "",
        html: `<div class='text-left'><p class='mb-50'>${this.$t("Your fee details are:")}</p>
         <b>${this.$t("Issue Date")}: </b>  ${new Date(
           this.settings.issueDate
         ).toLocaleDateString("en-UK", {
           year: "numeric",
           day: "numeric",
           month: "short",
         })}<br/>
        <b>${this.$t("Due Date")}: </b> ${new Date(this.settings.dueDate).toLocaleDateString(
          "en-UK",
          {
            year: "numeric",
            day: "numeric",
            month: "short",
          }
        )}<br/>
        <b>${this.$t("Expiry Date")}: </b> ${new Date(
          this.settings.expiryDate
        ).toLocaleDateString("en-UK", {
          year: "numeric",
          day: "numeric",
          month: "short",
        })}<br/>
        <p class='mt-1'>${this.$t("Are you sure you want to proceed?")}</p>
        </div>`,
        icon: "warning",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
        cancelButtonText: this.$t("Edit Settings"),
      });

      // console.log(result);
      if (result.isConfirmed) {
        if (text == "print") this.print();
        else if (text == "whatsapp") this.whatsApp();
        else if (text == "notification") this.sendNotification();
      } else if (result.dismiss == "cancel") {
        this.showSettings = true;
      }
      // let current = new Date().getMonth() + 1;
      // let bySetting = new Date(this.settings.dueDate).getMonth() + 1;

      // if (current != bySetting) {
      // } else {
      //   if (text == "print") this.print();
      //   else this.whatsApp();
      // }
    },
    async print() {
      this.iPrint = true;

      await this.LoadFSettings();
      var ffc = 0;
      var controller = this.resolveGenerateChallanController();
      if (controller === "GenerateChallanStudent") {
        ffc = -1;
      }

      try {
        var pObj = this.buildChallanGeneratePayload();

        var objData = await this.requestGenerateChallanFcIDs({
          controller,
          pObj,
          exp: false,
          postMessage: "Done successfully.",
        });

        if (objData && objData.length > 0) {
          this.openChallanPrintWindow(objData, ffc);
        }
      } catch (error) {
      } finally {
        this.iPrint = false;
      }
    },
    chunkArray(array, chunkSize) {
      try {
        console.log("Chunk started...");
        let results = [];
        while (array.length) {
          results.push(array.splice(0, chunkSize));
          console.log("Pushing...");
        }
        console.log("Result...", results);
        return results;
      } catch (error) {
        console.error(error);
      }
    },
    CheckPartialType() {
      var elem = this.$refs["type"];
      if (
        this.myObj.feesTypeIDs.length == 0 ||
        this.myObj.feesTypeIDs.length > 1
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    openPartial() {
      this.CheckMonths();
      this.CheckYear();
      this.CheckSec();
      this.CheckClass();
      if (
        this.CheckMonths() != false &&
        this.CheckYear() != false &&
        this.CheckSec() != false &&
        this.CheckClass() != false
      ) {
        if (this.CheckPartialType() == false) {
          this.$bvToast.toast(
            this.$t(
              "You can only create partial fee for 1 fee type at a time."
            ),
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        } else {
          this.$bvModal.show("modal-partial");
        }
      }
    },
    CheckPerc() {
      var elem = this.$refs["perc"];
      let x = parseFloat(this.partialPerc);
      if (isNaN(x) || x <= 0 || x > 100) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async savePartialFee() {
      if (this.CheckPerc() == true) {
        let ftt = this.feeTypes.find(
          (el) => el.id == this.myObj.feesTypeIDs[0]
        );
        let ft = ftt ? ftt.feeType : "";

        let cls = "All Classes";
        if (this.classID[0] !== 0) {
          let names = [];
          this.classID.forEach((el) => {
            let obj = this.classesOptions.find((elem) => elem.id == el);
            if (obj) names.push(obj.name);
          });

          cls = names.join(", ");
        }

        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "Do you want to create " + ft + " for " + cls + " ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes"),
        });
        if (result.isConfirmed) {
          if (this.classID[0] !== 0) {
            this.myObj.classIDs = this.classID;
          }
          if (this.secID[0] !== 0) {
            // console.log(this.secID);
            this.myObj.secIDs = this.secID;
          }
          this.partialPerc = parseFloat(this.partialPerc);
          let obj = this.prepareFeeRequestBody();
          obj = { ...obj, perc: this.partialPerc };

          this.partialrequest = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Fees/CreatePartialFee?db=" +
              this.$store.state.userData.db,
            body: obj,
            message: "Fee created successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.partialrequest = false;

          if (status) {
            this.$bvModal.hide("modal-partial");
            this.prevObj = this.myObj;
            this.myObj = {
              id: 0,
              year: new Date().getFullYear(),
              userID: this.$store.state.userData.userID,
              feesTypeIDs: [],
              months: [],
              excludedMonths: [],
              classIDs: [],
              secIDs: [],
              campusID: this.$store.state.userData.cId,
            };
            this.excludedMonthsList = [];
            this.selectedMonths = [];
            this.classID = [0];
            this.admittedSections = this.admittedSections = [
              { section: "All Sections", id: 0 },
            ];
            this.secID = [0];
          }
        }
      }
    },

    prepareFeeRequestBody(options = {}) {
      const body = { ...this.myObj };

      if (this.classID[0] !== 0) {
        body.classIDs = this.classID;
      }
      if (this.secID[0] !== 0) {
        body.secIDs = this.secID;
      }
      if (options.removeOnBehalf) {
        delete body.onBehalf;
      }
      if (this.usesAdmissionDateFilter) {
        if (this.admissionDateFrom) {
          body.admissionDateFrom = this.admissionDateFrom;
        }
        if (this.admissionDateTill) {
          body.admissionDateTill = this.admissionDateTill;
        }
      }

      return body;
    },
    resetFeeFormAfterCreate() {
      this.prevObj = this.myObj;
      this.myObj = {
        id: 0,
        year: new Date().getFullYear(),
        userID: this.$store.state.userData.userID,
        feesTypeIDs: [],
        months: [],
        excludedMonths: [],
        classIDs: [],
        secIDs: [],
        campusID: this.$store.state.userData.cId,
        onBehalf: 0,
      };
      this.excludedMonthsList = [];
      this.selectedMonths = [];
      this.classID = [0];
      this.admittedSections = [{ section: "All Sections", id: 0 }];
      this.secID = [0];
    },
    escapeHtml(value) {
      return String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    showFeeCreationSummary(data = {}) {
      const totalStudents = Number(data.totalStudents) || 0;
      const feesCreated =
        Number(data.feesCreated ?? data.studentsWithFeesCreated) || 0;
      const skippedAlreadyExists = Number(data.skippedAlreadyExists) || 0;
      const skippedZeroAmount = Number(data.skippedZeroAmount) || 0;
      const skippedStudents = Array.isArray(data.skippedZeroAmountStudents)
        ? data.skippedZeroAmountStudents
        : [];
      const studentIdLabel = this.isProfectusDomain ? "CID" : "ID";
      const hasSkippedSection = skippedZeroAmount > 0;
      const statCount =
        2 + (skippedAlreadyExists > 0 ? 1 : 0) + (hasSkippedSection ? 1 : 0);
      const modalWidth =
        statCount >= 4 || hasSkippedSection
          ? "50rem"
          : statCount === 3
          ? "42rem"
          : "34rem";

      let html = `
        <div class="fee-create-summary">
          <div class="fee-summary-stats fee-summary-stats-${statCount}">
            <div class="fee-stat-card fee-stat-total">
              <span class="fee-stat-value">${totalStudents}</span>
              <span class="fee-stat-label">${this.$t("Total Students")}</span>
            </div>
            <div class="fee-stat-card fee-stat-success">
              <span class="fee-stat-value">${feesCreated}</span>
              <span class="fee-stat-label">${this.$t("Fees Created")}</span>
            </div>
            ${
              skippedAlreadyExists > 0
                ? `
            <div class="fee-stat-card fee-stat-muted">
              <span class="fee-stat-value">${skippedAlreadyExists}</span>
              <span class="fee-stat-label">${this.$t("Already Exists")}</span>
            </div>`
                : ""
            }
            ${
              hasSkippedSection
                ? `
            <div class="fee-stat-card fee-stat-warning">
              <span class="fee-stat-value">${skippedZeroAmount}</span>
              <span class="fee-stat-label">${this.$t("Zero Amount")}</span>
            </div>`
                : ""
            }
          </div>
      `;

      if (hasSkippedSection) {
        html += `
          <div class="fee-skipped-panel">
            <div class="fee-skipped-panel-head">
              <div class="fee-skipped-panel-title">${this.$t(
                "Skipped Students"
              )}</div>
              <div class="fee-skipped-panel-subtitle">${this.$t(
                "These students were not billed because the fee amount is zero."
              )}</div>
            </div>
        `;

        if (skippedStudents.length > 0) {
          html += `
            <div class="fee-skipped-table-wrap">
              <table class="fee-skipped-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>${this.$t("Student Name")}</th>
                    <th>${studentIdLabel}</th>
                  </tr>
                </thead>
                <tbody>
          `;

          skippedStudents.forEach((student, index) => {
            const name = this.escapeHtml(student.name || this.$t("Unknown"));
            const studentId = student.sID ?? student.id ?? "-";
            html += `
              <tr>
                <td>${index + 1}</td>
                <td class="fee-student-name">${name}</td>
                <td>${this.escapeHtml(studentId)}</td>
              </tr>
            `;
          });

          html += `
                </tbody>
              </table>
            </div>
          `;
        } else {
          html += `
            <div class="fee-skipped-empty">${this.$t(
              "No student details were returned for skipped records."
            )}</div>
          `;
        }

        html += `</div>`;
      }

      html += `</div>`;

      Swal.fire({
        title: this.$t("Fee Creation Summary"),
        html,
        icon: "success",
        confirmButtonText: this.$t("Done"),
        width: modalWidth,
        padding: "1.5rem 1.75rem 1.25rem",
        customClass: {
          popup: `fee-summary-popup${
            statCount >= 4 ? " fee-summary-popup-wide" : ""
          }`,
          title: "fee-summary-title",
          htmlContainer: "fee-create-summary-container",
          confirmButton: "fee-summary-confirm-btn",
        },
      });
    },
    async saveFee() {
      this.CheckType();
      this.CheckMonths();
      this.CheckYear();
      this.CheckSec();
      this.CheckClass();
      if (
        this.CheckType() != false &&
        this.CheckMonths() != false &&
        this.CheckYear() != false &&
        this.CheckSec() != false &&
        this.CheckClass() != false
      ) {
        if (this.classID[0] !== 0) {
          this.myObj.classIDs = this.classID;
        }
        if (this.secID[0] !== 0) {
          // console.log(this.secID);
          this.myObj.secIDs = this.secID;
        }
        const requestBody = this.prepareFeeRequestBody();
        this.request = true;
        try {
          const response = await this.post({
            url:
              this.$store.state.domain +
              "Fees/CreateFeeAll?db=" +
              this.$store.state.userData.db,
            body: requestBody,
            context: this,
            token: this.$store.state.userData.token,
            allResponse: true,
          });

          if (response && response.status === "success") {
            const result = response.data || {};
            if (
              result.totalStudents != null ||
              result.feesCreated != null ||
              result.studentsWithFeesCreated != null
            ) {
              this.showFeeCreationSummary(result);
            } else {
              this.$bvToast.toast(
                response.message || this.$t("Fee created successfully."),
                {
                  title: this.$t("Success"),
                  variant: "success",
                  toaster: "b-toaster-top-center",
                }
              );
            }
            this.resetFeeFormAfterCreate();
          }
        } finally {
          this.request = false;
        }
      }
    },
    async holdFee() {
      this.CheckType();
      this.CheckMonths();
      this.CheckYear();
      this.CheckSec();
      this.CheckClass();
      if (
        this.CheckType() != false &&
        this.CheckMonths() != false &&
        this.CheckYear() != false &&
        this.CheckSec() != false &&
        this.CheckClass() != false
      ) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("Do you want to hold the selected fee?"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, Hold it!"),
        });

        if (result.isConfirmed) {
          this.holding = true;

          if (this.classID[0] !== 0) {
            this.myObj.classIDs = this.classID;
          }
          if (this.secID[0] !== 0) {
            // console.log(this.secID);
            this.myObj.secIDs = this.secID;
          }
          const requestBody = this.prepareFeeRequestBody({ removeOnBehalf: true });

          this.$bvToast.toast(this.$t("Fee hold is being processed"), {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-right",
          });

          var status = await this.postObj({
            url:
              this.$store.state.domain +
              "Fees/HoldFeeAll?db=" +
              this.$store.state.userData.db,
            body: requestBody,
            message: "Fee holded successfully.",
            context: this,
            ignoreTimeout: true,
            token: this.$store.state.userData.token,
          });
          console.log(status);
          this.holding = false;
          this.myObj = {
            id: 0,
            year: new Date().getFullYear(),
            userID: this.$store.state.userData.userID,
            feesTypeIDs: [],
            months: [],
            excludedMonths: [],
            classIDs: [],
            secIDs: [],
            campusID: this.$store.state.userData.cId,
          };
          this.excludedMonthsList = [];
          this.selectedMonths = [];
          this.classID = [0];
          this.admittedSections = this.admittedSections = [
            { section: "All Sections", id: 0 },
          ];
          this.secID = [0];
        }
      }
    },
    async unholdFee() {
      this.CheckType();
      this.CheckMonths();
      this.CheckYear();
      this.CheckSec();
      this.CheckClass();
      if (
        this.CheckType() != false &&
        this.CheckMonths() != false &&
        this.CheckYear() != false &&
        this.CheckSec() != false &&
        this.CheckClass() != false
      ) {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("Do you want to unhold the selected fee?"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, Unhold it!"),
        });

        if (result.isConfirmed) {
          this.holding = true;

          if (this.classID[0] !== 0) {
            this.myObj.classIDs = this.classID;
          }
          if (this.secID[0] !== 0) {
            // console.log(this.secID);
            this.myObj.secIDs = this.secID;
          }
          const requestBody = this.prepareFeeRequestBody({ removeOnBehalf: true });

          this.$bvToast.toast(this.$t("Fee unhold is being processed"), {
            title: this.$t("Success"),
            variant: "success",
            toaster: "b-toaster-top-right",
          });

          var status = await this.postObj({
            url:
              this.$store.state.domain +
              "Fees/UnholdFeeAll?db=" +
              this.$store.state.userData.db,
            body: requestBody,
            message: "Fee unhold successfully.",
            context: this,
            ignoreTimeout: true,
            token: this.$store.state.userData.token,
          });
          console.log(status);
          this.holding = false;
          this.myObj = {
            id: 0,
            year: new Date().getFullYear(),
            userID: this.$store.state.userData.userID,
            feesTypeIDs: [],
            months: [],
            excludedMonths: [],
            classIDs: [],
            secIDs: [],
            campusID: this.$store.state.userData.cId,
          };
          this.excludedMonthsList = [];
          this.selectedMonths = [];
          this.classID = [0];
          this.admittedSections = this.admittedSections = [
            { section: "All Sections", id: 0 },
          ];
          this.secID = [0];
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
<style>
.my-collapsing {
  height: 55px;
  overflow: hidden;
}
.my-collapsing.adjust {
  height: 39px;
}
.my-buttons {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
}
</style>
<style>
.fee-summary-popup {
  border-radius: 0.75rem !important;
  max-width: calc(100vw - 2rem) !important;
}
.fee-summary-popup-wide {
  width: 50rem !important;
}
.fee-summary-title {
  font-size: 1.35rem !important;
  font-weight: 700 !important;
  color: #2f2b3d !important;
  padding-bottom: 0.25rem !important;
}
.fee-create-summary-container {
  padding: 0.25rem 0.15rem 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}
.fee-summary-confirm-btn {
  min-width: 7rem;
  border-radius: 0.45rem !important;
  font-weight: 600 !important;
  padding: 0.55rem 1.5rem !important;
}
.fee-create-summary {
  text-align: left;
}
.fee-summary-stats {
  display: grid;
  gap: 0.85rem;
  margin-bottom: 0.25rem;
}
.fee-summary-stats-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.fee-summary-stats-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.fee-summary-stats-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.fee-stat-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.85rem 0.55rem;
  border-radius: 0.65rem;
  border: 1px solid transparent;
  min-height: 5rem;
}
.fee-summary-stats-4 .fee-stat-card {
  min-height: 4.75rem;
  padding: 0.7rem 0.45rem;
}
.fee-summary-stats-4 .fee-stat-value {
  font-size: 1.5rem;
}
.fee-summary-stats-4 .fee-stat-label {
  font-size: 0.7rem;
}
.fee-stat-value {
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1.1;
}
.fee-stat-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.25;
  color: #6e6b7b;
}
.fee-stat-total {
  background: #f3f2ff;
  border-color: #e3e1fc;
}
.fee-stat-total .fee-stat-value {
  color: #7367f0;
}
.fee-stat-success {
  background: #e8f8ef;
  border-color: #ccefd9;
}
.fee-stat-success .fee-stat-value {
  color: #28c76f;
}
.fee-stat-warning {
  background: #fff6ea;
  border-color: #ffe3bf;
}
.fee-stat-warning .fee-stat-value {
  color: #ff9f43;
}
.fee-stat-muted {
  background: #f8f8f8;
  border-color: #ebe9f1;
}
.fee-stat-muted .fee-stat-value {
  color: #6e6b7b;
}
.fee-skipped-panel {
  margin-top: 1rem;
  border: 1px solid #ffe3bf;
  border-radius: 0.65rem;
  background: #fffdf8;
  overflow: hidden;
}
.fee-skipped-panel-head {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #ffe8c7;
  background: linear-gradient(180deg, #fff9ef 0%, #fffdf8 100%);
}
.fee-skipped-panel-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #ff9f43;
}
.fee-skipped-panel-subtitle {
  margin-top: 0.2rem;
  font-size: 0.82rem;
  color: #8a7a66;
  line-height: 1.35;
}
.fee-skipped-table-wrap {
  max-height: 240px;
  overflow-y: auto;
}
.fee-skipped-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}
.fee-skipped-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff6ea;
  color: #8a6d3b;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  padding: 0.65rem 0.85rem;
  border-bottom: 1px solid #ffe3bf;
  white-space: nowrap;
}
.fee-skipped-table tbody td {
  padding: 0.62rem 0.85rem;
  border-bottom: 1px solid #fff0db;
  color: #5e5873;
  vertical-align: middle;
}
.fee-skipped-table tbody tr:last-child td {
  border-bottom: none;
}
.fee-skipped-table tbody tr:nth-child(even) {
  background: rgba(255, 249, 239, 0.65);
}
.fee-skipped-table tbody tr:hover {
  background: #fff3e0;
}
.fee-skipped-table tbody td:first-child {
  width: 2.5rem;
  color: #b9b9c3;
  font-weight: 600;
}
.fee-skipped-table tbody td:last-child {
  width: 5.5rem;
  font-weight: 600;
  color: #7367f0;
  white-space: nowrap;
}
.fee-student-name {
  font-weight: 600;
}
.fee-skipped-empty {
  padding: 0.9rem 1rem;
  font-size: 0.85rem;
  color: #8a7a66;
}
/* .swal2-styled {
  margin: 0.3125em;
} */
.v-select.set_multi .vs__dropdown-toggle {
  max-height: 300px !important;
  overflow-y: auto;
}

/* Async challan generation progress */
.challan-job-modal__content {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 22px 50px rgba(115, 103, 240, 0.2);
}

.challan-job-modal {
  padding: 1.75rem 1.5rem 1.5rem;
}

.challan-job-modal__wrap {
  text-align: center;
}

.challan-job-modal__loader {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 0.75rem;
  animation: challan-job-pulse 2.2s ease-in-out infinite;
}

@keyframes challan-job-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
}

.challan-job-modal__ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.challan-job-modal__ring-track,
.challan-job-modal__ring-fill {
  fill: none;
  stroke-width: 8;
}

.challan-job-modal__ring-track {
  stroke: #ece9ff;
}

.challan-job-modal__ring-fill {
  stroke: #7367f0;
  stroke-linecap: round;
  stroke-dasharray: 326.73;
  transition: stroke-dashoffset 0.5s ease;
}

.challan-job-modal__loader-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.challan-job-modal__percent {
  font-size: 1.75rem;
  font-weight: 700;
  color: #7367f0;
  letter-spacing: -0.02em;
}

.challan-job-modal__percent-sign {
  font-size: 0.95rem;
  font-weight: 600;
  color: #9b92f0;
  margin-left: 2px;
  margin-top: 0.35rem;
}

.challan-job-modal__icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto 0.65rem;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0eeff 0%, #e8e4ff 100%);
  color: #7367f0;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.15);
}

.challan-job-modal__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 0.35rem;
}

.challan-job-modal__message {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 0.75rem;
  line-height: 1.45;
}

.challan-job-modal__stat {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.2rem 0.35rem;
  margin-bottom: 1rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: #f8f7ff;
  border: 1px solid #e4e1ff;
}

.challan-job-modal__stat-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #7367f0;
}

.challan-job-modal__stat-sep {
  color: #b9b9c3;
  font-weight: 500;
}

.challan-job-modal__stat-total {
  font-size: 1rem;
  font-weight: 600;
  color: #5e5873;
}

.challan-job-modal__stat-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #8a8a96;
  margin-left: 0.15rem;
}

.challan-job-modal__bar-wrap {
  height: 6px;
  border-radius: 999px;
  background: #ece9ff;
  overflow: hidden;
  margin-bottom: 0.85rem;
}

.challan-job-modal__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #9e95f5 0%, #7367f0 55%, #6258cc 100%);
  transition: width 0.5s ease;
}

.challan-job-modal__hint {
  font-size: 0.75rem;
  color: #a8aaae;
  margin-bottom: 0;
  line-height: 1.4;
}
</style>
